<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">一筛选主播池</h1>
    <div class="filter-section">
      <el-row :gutter="20" class="filter-row">
        <el-col :span="6">
          <div class="filter-item">
            <label class="filter-label">激活时间</label>
            <el-date-picker
              v-model="platformData"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="retainedOptions"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="filter-item">
            <label class="filter-label">修改时间</label>
            <el-date-picker
              v-model="mplatformData"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="retainedOptions"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">主播状态</label>
            <el-select
              filterable
              v-model="hostStatus"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="total" :value="0"></el-option>
              <el-option label="考核中" :value="1"></el-option>
              <el-option label="第二次考核中" :value="2"></el-option>
              <el-option label="考核通过" :value="3"></el-option>
              <el-option label="直接淘汰" :value="4"></el-option>
              <el-option label="考核不通过淘汰" :value="5"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">国家</label>
            <el-select
              filterable
              v-model="country"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item, itemIndex) in countryList"
                v-bind:key="itemIndex + 99"
                :label="item.country"
                :value="item.countryCode"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">渠道</label>
            <el-select
              filterable
              v-model="channel"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in channelList"
                :key="item.value || item.channelId || index"
                :label="item.name || item.channelName || item.value"
                :value="item.value || item.channel || item.channelName"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="filter-row">
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">代理ID</label>
            <el-input v-model="agentId" placeholder="选填"></el-input>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">主播ID</label>
            <el-input v-model="rid" placeholder="选填"></el-input>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="filter-item button-group">
            <el-button type="warning" @click="getDayChatDetai" :loading="login1" size="medium">
              查询
            </el-button>
            <el-button type="success" @click="dwnDayChatDetai" :loading="login2" size="medium">
              下载
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        height="75vh"
        v-loading="login1"
        stripe
        border
      >
        <el-table-column prop="index" fixed label="No" width="80">
        </el-table-column>

        <el-table-column prop="rid" fixed label="主播id" width="80">
        </el-table-column>
        <el-table-column prop="head" fixed label="主播头像" width="180">
          <template slot-scope="scope">
            <el-image
              style="width: 180px; height: 180px"
              :src="scope.row.head"
              fit="contain"
              :preview-src-list="[scope.row.head]"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="主播昵称" width="180">
        </el-table-column
        ><el-table-column prop="country" label="主播国家" width="180">
        </el-table-column>
        <el-table-column prop="agentName" label="代理名" width="180">
        </el-table-column>

        <el-table-column prop="agentId" label="代理id" width="180">
        </el-table-column>
        <el-table-column
          prop="hostOnlineStatus"
          label="主播实时在线状态"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="hostStatus" label="状态" width="180">
        </el-table-column>
        <el-table-column prop="chatListVO" label="匹配通话通数" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.chatListVO.count }}</span>
            <el-popover placement="right" trigger="click">
              <el-table
                :data="scope.row.chatListVO.list"
                height="75vh"
                stripe
                border
              >
                <el-table-column type="index" fixed label="No" width="80">
                </el-table-column>
                <el-table-column
                  width="80"
                  property="chatTime"
                  label="通话时长（S）"
                ></el-table-column>
                <el-table-column
                  width="130"
                  property="chatDate"
                  label="通话时间"
                ></el-table-column>
                <el-table-column
                  width="130"
                  property="disuseReason"
                  label="是否有淘汰行为"
                ></el-table-column>
                <el-table-column
                  width="130"
                  property="videoUrl"
                  label="视频链接"
                >
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.videoUrl" type="primary" @click="palys(scope.row.videoUrl)"
                      >播放</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="primary" slot="reference" plain>
                查看详情
              </el-button>
            </el-popover>
            <el-button
              style="margin-top: 5px"
              v-show="getSendChance(scope.row.hostStatus)"
              type="primary"
              @click="sendChance(scope.row.rid)"
              plain
            >
              淘汰 => 一次试用
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="activationTime" label="激活时间" width="180">
        </el-table-column>
        <el-table-column prop="mtime" label="上次修改时间" width="180">
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="10"
      ></el-pagination>
    </el-row>

    <div class="showVieo" v-show="showVieo">
      <div>
        <div class="xx"><div @click="showVieo = false"></div></div>
        <video
          :src="srcMp4"
          controls="true"
          preoad="aoto"
          class="video vjs-big-play-centered"
          webkit-playsinline="true"
          :playsinline="true"
          x5-video-player-type="h5"
          x-webkit-airplay="allow"
          x5-playsinline
          muted="true"
          loop="false"
          ref="video"
        ></video>
      </div>
    </div>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountryMore, getLanguage } from '@/utils/normalApi.js'
import { getChannelList } from '@/api/baseRequest'

export default {
  data () {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(7), datainfor(1)],
      mplatformData: null,
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],
      hostStatus: 0,
      country: 'total',
      countryList: [],
      channel: '',
      channelList: [],
      agentId: '',
      rid: '',
      language: 'all',
      languageList: [],
      srcMp4: '',
      showVieo: false
    }
  },
  async created () {
    await this._getLanguage()
    this.getDayChatDetai()
    this._getCountry()
    this._getChannel()
  },
  methods: {
    palys (mp4) {
      if (!mp4) return
      this.showVieo = true
      this.srcMp4 = mp4
      setTimeout(() => {
        this.$refs.video.play()
      }, 300)
    },
    getSendChance (str) {
      if (str == '直接淘汰' || str == '考核不通过淘汰') {
        return true
      } else {
        return false
      }
    },
    async sendChance (rid) {
      const { data: res } = await this.$axios({
        method: 'POST',

        url: this.$store.getters.path.updateHostStatus,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid: rid,
          status: 1
        }
      })
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.getDayChatDetai()
    },
    async _getCountry () {
      const res = await getCountryMore()
      if (res !== null) {
        this.countryList = [
          { country: 'total', countryCode: '' },
          ...res.countryList
        ]
      }
    },
    async _getChannel () {
      const res = await getChannelList()
      this.channelList = [{ name: 'total', value: '' }, ...(res || [])]
    },

    async _getLanguage () {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai () {
      this.login1 = true
      if (this.platformData == null) {
        this.platformData = ['', '']
      }
      if (this.mplatformData == null) {
        this.mplatformData = ['', '']
      }

      const { data: res } = await this.$axios({
        method: 'POST',

        url: this.$store.getters.path.trial_host_pool,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token
        },
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          time: this.mplatformData[0],
          finish: this.mplatformData[1],
          hostStatus: this.hostStatus || 0,
          agentId: this.agentId,
          rid: this.rid,
          countryCode: this.country,
          channel: this.channel,
          page: this.page
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message.error(res.msg)
      let newList = []
      res.data.data.map((e, i) => {
        newList.push({ index: i + 1 + (this.page - 1) * 10, ...e })
      })
      this.dayChatDetailData = newList
      this.total = res.data.total
    },
    // 下载
    async dwnDayChatDetai () {
      this.login2 = true
      const res = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.trial_host_pool_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token
        },
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          time: this.mplatformData[0],
          finish: this.mplatformData[1],
          hostStatus: this.hostStatus || 0,
          agentId: this.agentId,
          rid: this.rid,
          countryCode: this.country,
          channel: this.channel,
          page: -1
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '匹配筛选主播池' + this.platformData[1])
    },

    // 分页
    handleCurrentChange () {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="scss" scoped>
.showVieo {
  position: fixed;
  top: 15%;
  left: 30%;
  z-index: 9999;
  .video {
    position: relative;

    width: 400px;
  }

  .xx {
    display: flex;
    justify-content: flex-end;
    > div {
      width: 40px;
      height: 40px;
      background: url('https://cdn3.qmovies.tv/youstar/op_sys_1692698699_xx.png')
        no-repeat;
      background-size: 100% auto;
    }
  }
}
.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .filter-section {
    margin-top: 20px;
    padding: 20px;
    background: #f5f7fa;
    border-radius: 4px;

    .filter-row {
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .filter-item {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .filter-label {
        font-size: 14px;
        color: #606266;
        font-weight: 500;
        white-space: nowrap;
      }

      &.button-group {
        flex-direction: row;
        align-items: flex-end;
        justify-content: flex-start;
        gap: 12px;
        padding-top: 8px;
      }
    }
  }

  .user-options {
    margin-top: 20px;

    .el-col {
      margin-bottom: 15px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
